
define("Wax/get!view-templates/linescore/jingle",["Wax/Wax"],function(Wax){return Wax.register("view-templates/linescore/jingle",'<header class="screen_reader">\n        <h1>Jingles go here.</h1>\n</header>\n<div class="jingleDisplay">\n   <div id=\'jingleContainer\'></div>\n</div>\n');});
